"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decideKeepDom = void 0;
function decideKeepDom(animationDuration, visible) {
    var _this = this;
    var willLeave = (!visible) && this._ALC_HELPER_prevVisible;
    this._ALC_HELPER_prevVisible = visible;
    if (visible) {
        return true;
    }
    if (!willLeave) {
        return false;
    }
    setTimeout(function () {
        _this.forceUpdate();
    }, animationDuration);
    return true;
}
exports.decideKeepDom = decideKeepDom;
